export enum AddTranscriptionToDocumentKeys {
    AddTranscriptionToDocumentDuration = "AddTranscriptionToDocumentDuration",
    AddTranscriptionSegmentToDocumentDuration = "AddTranscriptionSegmentToDocumentDuration",
    CharacterCount = "CharacterCount",
    FailureReason = "FailureReason",
    AddTranscriptionToDocumentOptionWithTimestamps = "AddTranscriptionToDocumentOptionWithTimestamps",
    AddTranscriptionToDocumentOptionWithSpeakers = "AddTranscriptionToDocumentOptionWithSpeakers"
};